import React, { useEffect, useState } from "react";
import SalesSummaryChart from "../../components/SalesSummaryChart";
import { useMutation } from "@tanstack/react-query";
import SupervisorApi from "../../utility/supervisorApi";
import SelectLabels from "../../components/SelectLabels";

function StoreManagementPerformance({ storeId, viewGraph }) {
  const { createData } = SupervisorApi();
  const [timeRange, setTimeRange] = useState(0);
  const [newPeriod, setNewPeriod] = useState("7days");
  const [dataset, setDataset] = useState(null); // Store the chart data
  const [store, setStore] = useState([]);

  const period = [
    { id: 0, key: "7days", time: "One Week" },
    { id: 1, key: "30days", time: "One Month" },
    { id: 2, key: "12months", time: "One Year" },
  ];

  // Change the selected period and update the period key
  useEffect(() => {
    chartData.mutate({ store_id: storeId, date_filter: newPeriod });
  }, [storeId, newPeriod]);

  const chartData = useMutation({
    mutationFn: (data) =>
      createData(`store-management/performance-overview`, data, true),
    onSuccess: (data) => {
      setStore(data);
    },
  });

  // Handle select dropdown change
  const handleChange = (value) => {
    setNewPeriod(period[value].key);
  };

  let formattedData = null;

  if (store?.data?.labels && store?.data?.datasets) {
    const { labels, datasets } = store?.data;

    formattedData = {
      labels: labels,
      datasets: datasets.map((item, index) => ({
        ...item,
        data: item.data.map((val) => parseFloat(val)),
        yAxisID: `y-axis-${index}`,
        borderColor: item.borderColor || "rgba(0, 0, 0, 0.1)",
        borderWidth: item.borderWidth || 1,
      })),
    };
  }

  return (
    <>
      {viewGraph ? (
        <div className="mb-20">
          <div className="flex justify-between">
            <h3 className="text-3xl font-semibold mb-2">
              Store Performance Overview
            </h3>
            <div>
              <SelectLabels
                valueKey="id"
                labelKey="time"
                text="Select a period"
                categoryData={period}
                onSelectChange={handleChange}
                // previousValue={defaultNum}
              />
            </div>
          </div>

          {/* Conditionally render the chart if the dataset is available */}
          {formattedData && (
            <SalesSummaryChart
              dataset={formattedData}
              datasets={formattedData.datasets}
            />
          )}
          <div className="flex justify-center">
            <h1 className="font-semibold text-xl my-3">
              {store?.data?.storeDetails?.store_name}
            </h1>
          </div>
        </div>
      ) : (
        <div className="">
          <h2 className="text-red-500 text-lg">
            *Click the View Icon on a Store to See the Performance Chart
          </h2>
        </div>
      )}
    </>
  );
}

export default StoreManagementPerformance;
